module.exports = __webpack_public_path__ + "media/images/members-079eba8f0b93e8f218aa7bb035c08f75.svg";